import type { FaireProductEntity } from "../../entity_types/product";

export const p_u94mww94hp: FaireProductEntity = {
  token: "p_u94mww94hp",
  type: "product",
  name: "Pumpkin Spice Chewing Gum - Natural + Plastic-Free | 6 Pack",
  brandToken: "b_65qc29zk",
  brandName: "Simply Gum",
  imageUrl:
    "https://cdn.faire.com/fastly/cd384e99d56aee28acaacf27850664298ed0a5be670fdb35135cc3b1e2606bfe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c9d2a7429a24c2d239ecfa28cf8ac13faab2039998ac6016ac63f2c9ed87385e.png",
    "https://cdn.faire.com/fastly/e67ee2df94a2e272da582cfde69c0d25968a876ff5a17b5cee6194cc91fdb303.jpeg",
    "https://cdn.faire.com/fastly/3828d65e32b2b01bd3432c8ebfa6e481f5013bfb19dcb78ba36430155e56cf43.jpeg",
    "https://cdn.faire.com/fastly/64a7754dfd7b5d6498d8740a674da9a1cfa8ef8d7d0ed4b5a221bd78c6c77f1a.jpeg",
    "https://cdn.faire.com/fastly/afefb1efa161b7ae376fb8b1b37a087d696a003b08f7a1a84343e3fca4831c31.jpeg",
    "https://cdn.faire.com/fastly/c4f0c2dfd9cc42a563589c147ef62e0124340352d181781158c1e710720284e6.jpeg",
    "https://cdn.faire.com/fastly/9c7cfa8daa9c1f05951a2e18e8d63583a280ecd9b1abb572c2c19d9b385f457c.jpeg",
    "https://cdn.faire.com/fastly/9838aaf51ab545aef6b1a9eca554653eca6b34de70faf032b2a611f65497156e.jpeg",
    "https://cdn.faire.com/fastly/c27128af8ee5d6bebf2c7747dbd6969a22c29e0b8f6c46a4d7937bc5359db8ac.jpeg",
  ],
  priceDollars: 1.8,
  description:
    'It\'s PUMPKIN SPICE SEASON! Don\'t miss out on this seasonal flavor. It\'ll only be around for a little while. Made with Pumpkin, Nutmeg, and Clove, our new Pumpkin Spice flavor tastes just like your favorite latte and pumpkin pie. Why Choose Simply Gum? Plant-Based & Plastic-Free   Made with chicle (tree sap) instead of synthetic gum bases. Made in the USA - Handcrafted in small batches in Brooklyn, New York. Truly Clean Ingredients   No aspartame, no sorbitol, no artificial sweeteners or synthetic flavors. Just smooth, balanced taste from real plant oils. Certified Better   Vegan, Non-GMO, and Kosher. Box Dimension: 2.5" x 2.5" x 0.6" Display Carton Dimension: 2.6" x 5.2" x 3.9" Shelf life: 365 days Size: 15 pieces/box | 12 boxes/inner 🏷️ flaire, candy, grocery, stocking stuffers, gourmet food, mother\'s day, summer, simple gum',
  tags: [],
  msrpDollars: 2.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:38.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
